import { render } from "./calendar.svg?vue&type=template&id=7206403e"
const script = {}

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__